'use client';

import {Box, styled} from '@mui/material';

export const StyledTopicCardImageContainer = styled(Box)(() => ({
  position: 'relative',
  width: '100%',
  aspectRatio: 'var(--topic-card-aspect-ratio, 16 / 9)',
  overflow: 'hidden',
}));

export const StyledTopicCardGridContainer = styled(Box)(({theme}) => ({
  width: '100%',
  paddingBottom: theme.spacing(2),
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: 'repeat(3, 1fr)',
  '--topic-card-aspect-ratio': '4 / 3',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(1, 1fr)',
  },
}));

export const StyledTopicCardFirstRowContainer = styled(StyledTopicCardGridContainer)(({theme}) => ({
  gridTemplateColumns: 'repeat(2, 1fr)',
  '--topic-card-aspect-ratio': '16 / 9',
  [theme.breakpoints.down('md')]: {
    '--topic-card-aspect-ratio': '4 / 3',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
  },
}));

export const StyledTopicCardRoot = styled(Box)(({ theme }) => ({
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadiusMd,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  margin: 'auto',
  width: '100%',
  maxWidth: 600,
  '&:hover img': {
    transform: 'scale(1.03)',
  },
  '& img': {
    transition: 'transform 400ms ease',
  },
  '& .heading': {
    position: 'relative',
    color: theme.palette.common.white,
    zIndex: 20,
  },
  '& .heading--title': {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    textOverflow: 'ellipsis',
    lineHeight: 1.15,
  },
}));

export const StyledTopicCardContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  bottom: 0,
  left: 0,
  justifyContent: 'space-between',
  zIndex: 3,
}));

export const StyledTopicCardContentContainer = styled(Box)(({theme}) => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: theme.spacing(1.5),
  background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%)',
}));

export const StyledTopicCardCtaContainer = styled(Box)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(1.5),
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.background.cardCtaBackground,
}));